module.exports = __webpack_public_path__ + "static/media/invoice-atulayalogo.43999a80.jpg";